import FullRender from './FullRender';

export default FullRender;
